import {ViewMode} from '@stripe-internal/support-conversations-controller';

import {assignRequestNavigation} from './assignRequestNavigate';
import {HeaderActionsContent} from './HeaderActionsContent';
import {useApp, useEntryPoint, useViewMode} from '../../../core/hooks/appHooks';

export function HeaderActions() {
  const app = useApp();
  const entryPoint = useEntryPoint();
  const viewMode = useViewMode();

  return (
    <HeaderActionsContent
      showMoreMenu={viewMode === ViewMode.Drawer}
      showSupportCenter={entryPoint === 'dashboard'}
      onRestartConversation={() => {
        app.restartConversation();
      }}
      onSupportCenterClick={() => {
        app.requestAction({
          action: {
            name: 'navigate',
            data: {
              route: {
                name: 'SUPPORT',
                params: {cad: {connectedAccountId: undefined}},
              },
            },
          },
        });
      }}
      supportCenterUses={[assignRequestNavigation()]}
    />
  );
}
